import {useIntl} from 'react-intl'
import {useQuery} from '@tanstack/react-query'
import {fetchContentAsset} from '../utils/content'
import {useAccessToken} from '@salesforce/commerce-sdk-react'

const useContentAsset = (contentId, queryOptions = {}) => {
    const {locale} = useIntl()
    const {getTokenWhenReady} = useAccessToken()

    return useQuery({
        ...queryOptions,
        queryKey: ['app', contentId, locale],
        queryFn: () => fetchContentAsset(contentId, {locale, getTokenWhenReady}),
        enabled: !!contentId
    })
}

export default useContentAsset
